export const seoDefaults = {
  siteUrl: 'https://hydrosprings.com',
  siteName: 'Hydrosprings',
  locale: 'en_US',
  twitterHandle: '@hydrosprings',
  themeColor: '#0A8299',
  ogImage:
    'https://cdn.magicpatterns.com/patterns/generated-images/c607324b-60f0-4347-9148-bbc4537d8d8b.jpg',
  logo: 'https://cdn.magicpatterns.com/uploads/3zVULXAcAAcS2CujfFojTe/LOGO-V1.jpg',
}

export interface PageSeo {
  title: string
  description: string
  path: string
  keywords: string
  image?: string
  imageAlt?: string
}

export const pageSeo: Record<'home' | 'shop' | 'technology' | 'contact', PageSeo> = {
  home: {
    title:
      'Hydrosprings | Chlorine-Free Pool System — 100% Chemical-Free Pool & Spa Water',
    description:
      'Hydrosprings installs Fusion 44X \u2014 the world\u2019s first self-maintaining, 100% chemical-free pool system. Patented Hydro-pH-Infusion holds pH at 7.2\u20137.6, kills algae and bacteria, and delivers water that meets EPA drinking-water standards. Zero chlorine, zero salt, zero chemicals.',
    path: '/',
    keywords:
      'chlorine free pool system, chemical free pool, chlorine alternative, pool water purification, Hydro-pH-Infusion, saltwater pool alternative, chemical free spa, EPA drinking water pool',
    imageAlt:
      'A modern swimming pool with completely clear, chlorine-free Hydrosprings water',
  },
  shop: {
    title: 'Shop Chlorine-Free Pool Systems | Spa, Residential & Commercial | Hydrosprings',
    description:
      'Four Hydrosprings systems retrofit into any existing pool or spa \u2014 spa and cold plunge, residential, large residential, and commercial. Financing available, lifetime warranty, 30-day money-back guarantee. Text us for pricing.',
    path: '/shop',
    keywords:
      'buy chlorine free pool system, chemical free spa system, cold plunge water system, residential pool sanitizer, commercial pool water treatment, pool system financing',
    imageAlt: 'Hydrosprings chlorine-free systems for spas, pools and commercial water',
  },
  technology: {
    title:
      'How Hydro-pH-Infusion Works | Chlorine-Free Pool Technology | Hydrosprings',
    description:
      'Pure science, no chemicals. See how the patented Fusion 44X Hydro-pH-Infusion process installed by Hydrosprings uses electrically charged hydrogen to balance pH to 7.2\u20137.6 and eliminate algae and bacteria \u2014 compared side by side against salt, UV, ozone, ionizer and copper systems.',
    path: '/technology',
    keywords:
      'Hydro-pH-Infusion, how chlorine free pools work, pool ionizer vs salt system, UV ozone pool comparison, hydrogen pool sanitation, pool pH balance technology',
    imageAlt:
      'A glass of clear, drinkable-standard water drawn from a Hydrosprings pool',
  },
  contact: {
    title: 'Contact Hydrosprings | Text Us About a Chemical-Free Pool',
    description:
      'Questions about going chlorine-free? Text Hydrosprings and a specialist replies \u2014 usually within minutes. Send your pool size and city for sizing, pricing and install timing.',
    path: '/contact',
    keywords:
      'contact Hydrosprings, chlorine free pool quote, pool system installer, chemical free pool pricing',
    imageAlt: 'Contact Hydrosprings about a chlorine-free pool system',
  },
}

export const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': `${seoDefaults.siteUrl}/#organization`,
  name: 'Hydrosprings',
  alternateName: 'Hydrosprings Chlorine-Free Swimming Pools',
  url: seoDefaults.siteUrl,
  logo: seoDefaults.logo,
  image: seoDefaults.ogImage,
  description:
    'Hydrosprings is an authorized dealer and installer of Fusion 44X, the world\u2019s first 100% chemical-free pool system, using patented Hydro-pH-Infusion to purify pool and spa water without chlorine, salt or additives.',
  areaServed: {
    '@type': 'Country',
    name: 'United States',
  },
  contactPoint: [
    {
      '@type': 'ContactPoint',
      contactType: 'sales',
      availableLanguage: ['English'],
      areaServed: 'US',
    },
  ],
}

export const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${seoDefaults.siteUrl}/#website`,
  url: seoDefaults.siteUrl,
  name: 'Hydrosprings',
  description: pageSeo.home.description,
  publisher: { '@id': `${seoDefaults.siteUrl}/#organization` },
  inLanguage: 'en-US',
}
